import { Component } from '@angular/core';
import { ToastService } from '../services/toast.service';
import { ToastComponent } from './toast/toast.component';


@Component({
    selector: 'app-toasts',
    templateUrl: './toasts.component.html',
    styleUrls: ['./toasts.component.scss'],
    imports: [ToastComponent]
})
export class ToastsComponent {

  constructor(public toastService: ToastService) {}
}
